import { changeLanguage } from 'redux/modules/i18n';
import cookie from 'react-cookie';
import counterpart from 'counterpart';
import moment from 'moment';

class CookieUtils {

  static availableLangiages = ['se', 'en'];

  static cookieDomain () {
    var domainParts = location.hostname.split('.');
    if (domainParts.length > 2) {
      domainParts.shift();
    }
    return domainParts.join('.');
  }

  static wildCardCookieDomain () {
    var domainParts = location.hostname.split('.');
    var domain = location.hostname;
    if (domainParts.length > 2) {
      domain = '.' + domainParts[domainParts.length - 2] + '.' + domainParts[domainParts.length - 1];
    }
    return domain;
  }

  static setLanguageFromCookie (store) {
    var ffLanguage = cookie.load('ff_language');
    if (typeof ffLanguage !== 'undefined' && ffLanguage !== counterpart.getLocale()) {
      ffLanguage = this.availableLangiages.includes(ffLanguage) ? ffLanguage : 'se';
      store.dispatch(changeLanguage(ffLanguage));
      this.setHtmlLangFromStore(ffLanguage);
    }
  }

  static setHtmlLangFromStore (lang) {
    const htmlLang = lang === 'se' ? 'sv' : 'en';
    document.documentElement.lang = htmlLang;
  }

  static setLanguageCookie (lang) {
    cookie.save('ff_language', lang, {
      domain: this.cookieDomain(),
      expires: moment().add(24, 'hours').toDate()
    });
  }

  static setNameCookie (name) {
    cookie.save('ff_name', name, {
      domain: this.cookieDomain(),
      expires: moment().add(24, 'hours').toDate()
    });
  }

  static setHidePhoneNumberModalCookie () {
    cookie.save('ff_hide_phone_number', true, {
      domain: this.cookieDomain(),
      expires: moment().add(24, 'hours').toDate()
    });
  }

  static getHidePhoneNumberModalCookie () {
    return cookie.load('ff_hide_phone_number');
  }

  static setRegisterAssignmentToolVisited () {
    cookie.save('ff_register_visited', true);
  }

  static getRegisterAssignmentToolVisited () {
    return cookie.load('ff_register_visited');
  }

  static setInfoBannerClosed (text) {
    cookie.save('ff_info_banner_closed', text);
  }

  static getInfoBannerClosed (text) {
    return cookie.load('ff_info_banner_closed') === text;
  }

  static removeNameCookie () {
    cookie.remove('ff_name', { domain: this.cookieDomain() });
  }

  static updateNameCookie () {
    var ffName = cookie.load('ff_name');
    if (ffName !== 'undefined') {
      this.setNameCookie(ffName);
    }
  }

  static getUtmParamsCookie () {
    return cookie.load('utm_params');
  }

  static removeUtmParamsCookie () {
    return cookie.remove('utm_params', { domain: this.wildCardCookieDomain() });
  }
}

export default CookieUtils;



/** WEBPACK FOOTER **
 ** ./src/frilans-finans/utils/cookie-utils.js
 **/